import { createSlice } from '@reduxjs/toolkit';
import {
  GET_ALL_PARTS,
  GET_ALL_CHAPTERS,
  GET_ALL_TOPICS
} from '../constants/constants.js';

const initialState = {
  parts: [],
  chapters: [],
  topics: []
};

const bookSectionsSlice = createSlice({
  name: 'bookSection',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(GET_ALL_PARTS, (state, action) => {
        state.parts = action.data;
      })
      .addCase(GET_ALL_CHAPTERS, (state, action) => {
        state.chapters = action.data;
      })
      .addCase(GET_ALL_TOPICS, (state, action) => {
        state.topics = action.data;
      });
  }
});

export default bookSectionsSlice.reducer;
